module.exports = __webpack_public_path__ + "images/components/estimate_banners/form_with_image/callout_pc_6574695f9018d63ae9010db5dafb4e23.svg";